// Real tournament data behind the World Cup 2026 case study widgets.
// Scores and point totals are real (see the case-study FINAL_NUMBERS
// ledger); participant names are fictional.

export const TEAM_NAMES = {
  he: {
    France: 'צרפת', Morocco: 'מרוקו', Spain: 'ספרד', Belgium: 'בלגיה',
    Norway: 'נורבגיה', England: 'אנגליה', Argentina: 'ארגנטינה',
    Switzerland: 'שוויץ', Brazil: 'ברזיל',
  },
  en: {
    France: 'France', Morocco: 'Morocco', Spain: 'Spain', Belgium: 'Belgium',
    Norway: 'Norway', England: 'England', Argentina: 'Argentina',
    Switzerland: 'Switzerland', Brazil: 'Brazil',
  },
};

// Knockout road: the real 90-minute results, as stored and shown.
export const GAMES = [
  { h: 'France',    a: 'Morocco',     s: '2-0', st: { he: 'רבע גמר', en: 'Quarter-final' } },
  { h: 'Spain',     a: 'Belgium',     s: '2-1', st: { he: 'רבע גמר', en: 'Quarter-final' } },
  { h: 'Norway',    a: 'England',     s: '1-1', st: { he: 'רבע גמר', en: 'Quarter-final' } },
  { h: 'Argentina', a: 'Switzerland', s: '1-1', st: { he: 'רבע גמר', en: 'Quarter-final' } },
  { h: 'France',    a: 'Spain',       s: '0-2', st: { he: 'חצי גמר', en: 'Semi-final' } },
  { h: 'England',   a: 'Argentina',   s: '1-2', st: { he: 'חצי גמר', en: 'Semi-final' } },
  { h: 'France',    a: 'England',     s: '4-6', st: { he: 'מקום שלישי', en: 'Third place' } },
  { h: 'Spain',     a: 'Argentina',   s: '0-0', st: { he: 'גמר', en: 'Final' } },
];

// Standings: real closing totals of one community's top 8, fictional names
// (Hebrew names on the Hebrew page, common international names in English).
export const STANDINGS = [
  { he: 'שמעון לוי',  en: 'Lucas W.',  pts: 216, avatar: 8 },
  { he: 'נועה כהן',   en: 'Sofia R.',  pts: 201, avatar: 16 },
  { he: 'איתי פרץ',   en: 'Daniel K.', pts: 200, avatar: 18 },
  { he: 'דנה אברהם',  en: 'Emma S.',   pts: 199, avatar: 21 },
  { he: 'יוסי מזרחי', en: 'Alex M.',   pts: 199, avatar: 22, me: true },
  { he: 'רותם שקד',   en: 'Mia T.',    pts: 198, avatar: 38 },
  { he: 'אור ביטון',  en: 'Leo B.',    pts: 198, avatar: 42 },
  { he: 'ליאור חדד',  en: 'Olivia H.', pts: 197, avatar: 44 },
];

// Settlement replay: six REAL user rows from one community (names
// fictional); base = final total minus the 25 the crown added.
export const SETTLE = [
  { he: 'דנה אברהם', en: 'Emma S.',   avatar: 21, base: 200, team: 'Brazil',    hit: false },
  { he: 'נועה כהן',  en: 'Sofia R.',  avatar: 16, base: 176, team: 'Spain',     hit: true },
  { he: 'איתי פרץ',  en: 'Daniel K.', avatar: 18, base: 183, team: 'France',    hit: false },
  { he: 'רותם שקד',  en: 'Mia T.',    avatar: 38, base: 174, team: 'Spain',     hit: true },
  { he: 'אור ביטון', en: 'Leo B.',    avatar: 42, base: 175, team: 'Argentina', hit: false },
  { he: 'ליאור חדד', en: 'Olivia H.', avatar: 44, base: 173, team: 'Spain',     hit: true },
];

export const CHAMPION_BONUS = 25;

// The signed-in user shown in every phone's header: the "me" row above.
export const ME = STANDINGS.find((r) => r.me);
